import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    page: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXXL,
        padding: tokens.spacingHorizontalSNudge,
    },
});
